import React from 'react';

import { Box, Divider, Stack, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactHookFormSelect } from 'common/components/form';

import CommonFields from '../../../components/fields/CommonFields';

const BaseParameters = ({
    algorithmOptions = [],
    control,
    disabled,
    fieldsMappingByAlgorithm,
}) => {
    const { t } = useTranslation();
    const typeAlgorithm = useWatch({ control, name: 'type_algorithm' });

    const fieldsToRender = fieldsMappingByAlgorithm[typeAlgorithm] || [];

    return (
        <Box>
            <CommonFields control={control} disabled={disabled} />

            <Typography fontWeight="bold" variant="body2">
                {t('Configure your product')}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Stack>
                <ReactHookFormSelect
                    control={control}
                    disabled={disabled}
                    label={t('Algorithm for run')}
                    name="type_algorithm"
                    options={algorithmOptions}
                />

                {fieldsToRender.map((field, index) => (
                    <React.Fragment key={index}>{field}</React.Fragment>
                ))}
            </Stack>
        </Box>
    );
};

BaseParameters.propTypes = {
    algorithmOptions: PropTypes.array.isRequired,
    control: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    fieldsMappingByAlgorithm: PropTypes.object.isRequired,
};

export default BaseParameters;
